import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service.service';
import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = false;
  validUser = false;
  constructor(
    private httpService: HttpService,
    private http: HttpClient
  ) {}

  ValidateToken(): Observable<any> {
    return this.httpService.post(environment.ValidateToken, '');
  }

  ValidateToken1(): any {
    return this.httpService.post(environment.ValidateToken, '').toPromise();
  }
  isAuthenticated() {
    return this.isLoggedIn;
  }

  async ValidateToken2(): Promise<any> {
    await firstValueFrom(this.http.post<boolean>(environment.ValidateToken, ''))
      .then((value) => {
        console.log(`Result: ` + value);
        return true;
      })
      .catch((error) => {
        console.log(`Result: ` + error);
        return false;
      });
  }

  ValidateToken3(): Observable<any> {
    return this.http.post<any>(environment.ValidateToken, '');
  }
}
